/** رقم‌های بدون واحد؛ نمایش با جداکننده هزار فارسی یا لاتین */
export function formatRial(n: number, locale = 'fa-IR'): string {
  if (Number.isNaN(n)) return '۰';
  return n.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

/** فقط ارقام لاتین از ورودی مبلغ (با جداکننده هزار / فارسی) */
export function parseAmountDigits(raw: string): string {
  const map: Record<string, string> = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
  };
  return raw
    .split('')
    .map((ch) => map[ch] ?? ch)
    .join('')
    .replace(/[^\d]/g, '');
}

/** نمایش مبلغ با جداکننده هزار لاتین هنگام تایپ: 1000000 → 1,000,000 */
export function formatAmountInput(raw: string): string {
  const digits = parseAmountDigits(raw);
  if (!digits) return '';
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
